import ApiBase from './ApiBase';
import axios from 'axios';
/**
 * Entitlement API
 */
class EntitlementApi extends ApiBase {
  /**
   * Get user authorizations by role
   * @param {*} filters Array of filter objects
   */
  async getAuthorizationsByRole(filters) {
    const request = {
      url: `${this.API_URL}/userauthorizations/byrole`,
      headers: this.getHeaders(),
      method: 'POST',
      data: JSON.stringify(filters)
    };
    const response = await axios.request(request);
    if (response.status !== 200) {
      throw new Error(response.statusText);
    }
    return response.data;
  }

  /**
   * Get user authorizations by userId
   * @param userId
   */
  getAuthorizationsByUserId = async userId => {
    const request = {
      url: `${this.API_URL}/userauthorizations?userId=${userId}`,
      headers: this.getHeaders(),
      method: 'GET'
    };

    const response = await axios.request(request);

    return response.data && response.data.pageData;
  };

  /**
   * Get user authorizations by userId
   * @param {*} userauthorizations Array of filter objects
   */
  createAuthorizations = async userauthorizations => {
    const request = {
      url: `${this.API_URL}/userauthorizations`,
      headers: this.getHeaders(),
      method: 'POST',
      data: JSON.stringify(userauthorizations)
    };

    const response = await axios.request(request);

    return response.data && response.data.pageData;
  };
  /**
   * Get user authorizations by userId and investorId
   * @param investorId
   */
  getAuthorizationsByInvestorId = async investorId => {
    const request = {
      url: `${this.API_URL}/userauthorizations?investorId=${investorId}`,
      headers: this.getHeaders(),
      method: 'GET'
    };

    const response = await axios.request(request);

    return response.data;
  };
}
export default new EntitlementApi();
